// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ****Fonts**** */
/* ****Shadows (subtle elevation — flat SaaS)**** */
/* ****Border radius**** */
/* ****icon size**** */
/* **** Device width **** */
/* **** helper variable **** */
/* **** Motion **** */
.MainLayout_container__YzzQu {
  display: flex;
  min-height: 100vh;
}

.MainLayout_main__i-uQO {
  background-color: var(--bgc);
  overflow-x: hidden;
  flex-grow: 1;
}
.MainLayout_main__content__cj1sA {
  min-height: 100vh;
  padding: 1.25rem 2rem 2rem 17.5rem;
  transition: padding 200ms cubic-bezier(0.16, 1, 0.3, 1);
}
@media only screen and (max-width: 768px) {
  .MainLayout_main__content__cj1sA {
    padding: 1rem;
  }
}
.MainLayout_main__content__cj1sA.MainLayout_close_sidebar__8LbbJ {
  padding: 1.25rem 2rem 2rem 6rem;
}
@media only screen and (max-width: 768px) {
  .MainLayout_main__content__cj1sA.MainLayout_close_sidebar__8LbbJ {
    padding: 1rem;
  }
}
@media only screen and (max-width: 768px) {
  .MainLayout_main__content__cj1sA {
    position: relative;
    background-color: var(--bgc);
    z-index: 100;
  }
}
@media only screen and (max-width: 576px) {
  .MainLayout_main__content__cj1sA {
    padding: 1rem;
  }
}

html[dir=rtl] .MainLayout_main__content__cj1sA {
  padding: 1.25rem 17.5rem 2rem 2rem;
}
html[dir=rtl] .MainLayout_main__content__cj1sA.MainLayout_close_sidebar__8LbbJ {
  padding: 1.25rem 6rem 2rem 2rem;
}
@media only screen and (max-width: 768px) {
  html[dir=rtl] .MainLayout_main__content__cj1sA.MainLayout_close_sidebar__8LbbJ {
    padding: 0.8rem 2rem;
  }
}
@media only screen and (max-width: 768px) {
  html[dir=rtl] .MainLayout_main__content__cj1sA {
    padding: 0.8rem 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/layout/MainLayout.module.scss","webpack://./src/scss/abstracts/_variables.scss","webpack://./src/scss/abstracts/_mixins.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB,kBAAA;AAeA,mDAAA;AAIA,0BAAA;AAKA,sBAAA;AAIA,2BAAA;AAMA,8BAAA;AAOA,qBAAA;ADvCA;EACE,aAAA;EACA,iBAAA;AAOF;;AAJA;EACE,4BAAA;EACA,kBAAA;EACA,YAAA;AAOF;AALE;EACE,iBAAA;EACA,kCAAA;EACA,uDAAA;AAOJ;AEPE;EFHA;IAKI,aAAA;EASJ;AACF;AARI;EACE,+BAAA;AAUN;AEfE;EFIE;IAGI,aAAA;EAYN;AACF;AEpBE;EFHA;IAeI,kBAAA;IACA,4BAAA;IACA,YAAA;EAYJ;AACF;AEjCE;EFGA;IAqBI,aAAA;EAaJ;AACF;;AARE;EACE,kCAAA;AAWJ;AAVI;EACE,+BAAA;AAYN;AEvCE;EF0BE;IAGI,oBAAA;EAcN;AACF;AE5CE;EFwBA;IASI,oBAAA;EAeJ;AACF","sourcesContent":["@use \"../scss/abstracts/\" as *;\r\n\r\n.container {\r\n  display: flex;\r\n  min-height: 100vh;\r\n}\r\n\r\n.main {\r\n  background-color: var(--bgc);\r\n  overflow-x: hidden;\r\n  flex-grow: 1;\r\n\r\n  &__content {\r\n    min-height: 100vh;\r\n    padding: 1.25rem 2rem 2rem 17.5rem;\r\n    transition: padding $duration-base $ease-out;\r\n    @include tablet {\r\n      padding: 1rem;\r\n    }\r\n    &.close_sidebar {\r\n      padding: 1.25rem 2rem 2rem 6rem;\r\n      @include tablet {\r\n        padding: 1rem;\r\n      }\r\n    }\r\n\r\n    @include tablet {\r\n      position: relative;\r\n      background-color: var(--bgc);\r\n      z-index: 100;\r\n    }\r\n\r\n    @include mobile {\r\n      padding: 1rem;\r\n    }\r\n  }\r\n}\r\n\r\nhtml[dir=\"rtl\"] {\r\n  .main__content {\r\n    padding: 1.25rem 17.5rem 2rem 2rem;\r\n    &.close_sidebar {\r\n      padding: 1.25rem 6rem 2rem 2rem;\r\n      @include tablet {\r\n        padding: 0.8rem 2rem;\r\n      }\r\n    }\r\n    @include tablet {\r\n      padding: 0.8rem 2rem;\r\n    }\r\n  }\r\n}\r\n","/* ****Fonts**** */\r\n\r\n//Body size\r\n$fontSizeBodySmall: 12px;\r\n$fontSizeBodyMedium: 14px;\r\n$fontSizeBodyLarge: 16px;\r\n//Headline size\r\n$fontSizeHeadlineSmall: 24px;\r\n$fontSizeHeadlineMedium: 36px;\r\n$fontSizeHeadlineLarge: 48px;\r\n//Display size\r\n$fontSizeDisplaySmall: 56px;\r\n//helper font size\r\n$fontSizeTableStatus: 11px;\r\n\r\n/* ****Shadows (subtle elevation — flat SaaS)**** */\r\n$mainBoxShadow: 0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.06);\r\n$secondBoxShadow: 0 12px 40px rgba(15, 23, 42, 0.18);\r\n\r\n/* ****Border radius**** */\r\n$smallBorderRadius: 8px;\r\n$mediumBorderRadius: 12px;\r\n$largeBorderRadius: 16px;\r\n\r\n/* ****icon size**** */\r\n$smallIconSize: 20px;\r\n$largeIconSize: 48px;\r\n\r\n/* **** Device width **** */\r\n$mobile-width: 576px;\r\n$tablet-width: 768px;\r\n$desktop-width: 992px;\r\n$largeDesktop-width: 1200px;\r\n\r\n/* **** helper variable **** */\r\n$sideBarOpenWidth: 248px;\r\n$sideBarCloseWidth: 72px;\r\n$spacing: 60px;\r\n$mobileSpacing: 16px;\r\n$sideBarLogoHeight: 171px;\r\n\r\n/* **** Motion **** */\r\n$ease-out: cubic-bezier(0.16, 1, 0.3, 1);\r\n$duration-fast: 150ms;\r\n$duration-base: 200ms;\r\n","@use './variables' as *;\r\n\r\n@mixin flex($alignItem: center, $justifyContent: center) {\r\n  display: flex;\r\n  align-items: $alignItem;\r\n  justify-content: $justifyContent;\r\n}\r\n\r\n@mixin mobile {\r\n  @media only screen and (max-width: $mobile-width) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin tablet {\r\n  @media only screen and (max-width: $tablet-width) {\r\n    @content;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `MainLayout_container__YzzQu`,
	"main": `MainLayout_main__i-uQO`,
	"main__content": `MainLayout_main__content__cj1sA`,
	"close_sidebar": `MainLayout_close_sidebar__8LbbJ`
};
export default ___CSS_LOADER_EXPORT___;
